import React from 'react';

import { Global } from '@emotion/core';

// Theme
import { ThemeProvider } from 'emotion-theming';
import { themeBuilder } from '@cybs-plugins/theme';

// VDS React
import '@visa/vds-react/_stys/vds.min.css';
import GlobalStyles from '@visa/vds-react/global-styles';
import Icons from '@visa/vds-react/icons-styled';

import globalStyles from './component.styles';

export function CoreThemedStyles(WrappedComponent, themeOptions = {}) {
  function CoreThemedStylesFunction(props) {
    const theme = themeBuilder(themeOptions);

    return (
      <>
        <Global styles={theme.global.type} />
        <Global styles={globalStyles} />

        <ThemeProvider theme={theme}>
          <Icons />
          <GlobalStyles />
          <WrappedComponent {...props} />
        </ThemeProvider>
      </>
    );
  }

  CoreThemedStylesFunction.displayName = 'CoreThemedStyles';
  return CoreThemedStylesFunction;
}
export { globalStyles };
export default CoreThemedStyles;
